import { render, staticRenderFns } from "./productDisplay.vue?vue&type=template&id=043f240b&scoped=true&"
import script from "./productDisplay.vue?vue&type=script&lang=js&"
export * from "./productDisplay.vue?vue&type=script&lang=js&"
import style0 from "./productDisplay.vue?vue&type=style&index=0&id=043f240b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043f240b",
  null
  
)

export default component.exports